<template>
    <div class="container">
        <div v-if="loaded">
            <div v-if="!error">
                <app-logo :title="title" />
                <app-step :step="step" :labels="labels" />
                <div class="row">
                    <div class="col-md-8">
                        <form-oc 
                            :course="course"
                            :step="step"
                            @update="updateStep"
                            v-if="category == 'OC'"> 
                        </form-oc>
                        <form-cdl 
                            :step="step"
                            :course="course"
                            @update="updateStep"
                            v-else-if="category == 'CDL'">
                        </form-cdl>
                        <form-ic 
                            :step="step"
                            :course="course"
                            @update="updateStep"
                            v-else-if="category == 'IC'">
                        </form-ic>
                        <form-fit 
                            :step="step"
                            @update="updateStep"
                            v-else-if="category == 'FIT'">
                        </form-fit>
                    </div>
                    <div class="col-md-4 mt-3 mt-md-0">
                        <app-summary />
                    </div>
                </div>
                <app-footer />
            </div> 
            <div v-else>
                <div class="alert alert-danger my-5 w-50 mx-auto text-center">
                    <h5>Impossibile proseguire</h5>
                    <p class="mb-0">{{ error }}</p>
                </div>
            </div>
        </div>
        <div v-else> 
            <app-loading />
        </div>
    </div>
</template>

<script>
    import AppLogo from './components/ui/AppLogo'
    import AppStep from './components/ui/AppStep'
    import AppFooter from './components/ui/AppFooter'
    import AppLoading from './components/ui/AppLoading'
    import FormCdl from './components/form/FormCdl'
    import FormOc from './components/form/FormOc'
    import FormIc from './components/form/FormIc'
    import FormFit from './components/form/FormFit'
    import AppSummary from './components/ui/AppSummary'
    import cookieconsent from './mixins/cookieconsent'
    import axios from 'axios'
    import * as services from './services';

    export default {
        components: {
            AppLogo,
            AppStep,
            AppFooter,
            AppLoading,
            FormCdl,
            FormOc,
            FormIc,
            FormFit,
            AppSummary
        },
        mixins: [cookieconsent],
        data() {
            return {
                step: 1,
                title: null,
                course: null,
                loaded: false,
                error: false
            }
        },
        computed: {
            category() {
                return this.$store.getters['settings/category']
            },
            api() {
                return this.$store.getters['settings/from'].api
            },
            course_code() {
                return this.$store.getters['settings/course_code']
            },
            token() {
                return this.$store.getters['settings/token']
            },
            aa() {
                return this.$store.getters['settings/aa']
            },
            labels() {
                return [
                    this.$t("calcolo_retta"),
                    this.$t("dati_anagrafici"),
                    this.$t("recapiti"),
                    this.$t("area_personale")
                ]
            }
        },
        methods: {
            updateStep(step) {
                this.step = step
            },
            async getCdlCourse() {
                this.$store.dispatch('summary/setCategory', 'Corso di Laurea')
                if (this.course_code) {
                    try {
                        const data = await services.ecp.post('api/get/graduate/courses');
                        const course = data.data.filter(el => el.code == this.course_code)
                        if (course.length > 0) {
                            this.course = course[0]
                            this.title = this.course.name
                            this.error = false
                        } else {
                            this.error = 'Il corso selezionato non esiste!'
                        }
                    } catch(error) {
                        this.error = 'Errore di risposta dal server, riprova più tardi.'
                        console.log(error)
                    }
                } else {
                    this.title = this.$t('corsi_di_laurea')
                    this.error = false
                }
            },
            async getOcCourse() {
                if (this.course_code) {
                    try {
                        const data = await services.ecp.get(`api/get/oc/course/${this.course_code}`)
                        console.log(data);
                        if (data.data) {
                            this.course = data.data
                            this.title = this.course.title
                            this.$store.dispatch('summary/setCategory', this.course.description)
                            this.error = false
                        } else {
                            this.error = 'Il corso selezionato non esiste!'
                        }
                    } catch(error) {
                        this.error = 'Errore di risposta dal server, riprova più tardi.'
                        console.log(error)
                    }
                } else {
                    this.title = 'Corsi Post-laurea/Post-diploma'
                    this.error = false
                }
            },
            async getCourse() {
                switch (this.category) {
                    case 'CDL':
                        await this.getCdlCourse()
                        break 
                    case 'OC':
                        await this.getOcCourse()
                        break 
                    case 'IC':
                        this.title = 'Esami Singoli'
                        this.$store.dispatch('summary/setCategory', 'Esami Singoli')
                        break
                    case 'FIT':
                        this.title = '24 CFU'
                        this.$store.dispatch('summary/setCategory', '24 CFU')
                        this.$store.dispatch('summary/setCourse', '24 CFU')
                        break
                }
            },
            
        },
        async mounted() {
            this.$gclid()
            await this.getCourse()
            this.loaded = true
            console.log('Mounted App')
        }
    }
</script>

<style>
    /*.vs__dropdown-toggle {
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e")!important;
        background-repeat: no-repeat!important;
        background-position: right .75rem center!important;
        background-size: 16px 12px!important;
    }*/

    .vs--disabled .vs__clear, 
    .vs--disabled .vs__dropdown-toggle, 
    .vs--disabled .vs__open-indicator, 
    .vs--disabled .vs__search, 
    .vs--disabled .vs__selected {
        background-color:#e9ecef!important;
        color:#6c757d!important;
        opacity: 0.7;
    }

    .vs--disabled .vs__dropdown-toggle {
        border:1px solid #ced4da!important;
    }
</style>